;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export const CLIENT_INVALIDATION_EVENT_TYPE = {
	agentExecutionUpdated: "agent.execution.updated",
	alertChanged: "alert.changed",
	automationStateChanged: "automation.state.changed",
	commentChanged: "comment.changed",
	executionUpdated: "execution.updated",
	notificationChanged: "notification.changed",
	usageTrackingChanged: "usage.tracking.changed",
	userSettingsChanged: "user.settings.changed",
	visualizationStale: "visualization.stale",
	workflowChanged: "workflow.changed",
	workspaceMembershipChanged: "workspace.membership.changed",
} as const;

export const CLIENT_INVALIDATION_PATH = {
	ingest: "/api/internal/client-invalidations",
	sse: "/api/realtime/events",
} as const;

export const CLIENT_INVALIDATION_REDIS_CHANNEL = {
	organization: "client-invalidation:organization:",
	user: "client-invalidation:user:",
	workspace: "client-invalidation:workspace:",
} as const;

export const CLIENT_INVALIDATION_SSE_EVENT = {
	invalidation: "invalidation",
} as const;

export const CLIENT_INVALIDATION_CONNECTION_STATUS = {
	closed: "closed",
	open: "open",
} as const;

export const CLIENT_INVALIDATION_HEARTBEAT_MS = 15_000;

export const CLIENT_INVALIDATION_SEARCH_PARAM = {
	workspaceId: "workspaceId",
} as const;

export type ClientInvalidationEventType =
	(typeof CLIENT_INVALIDATION_EVENT_TYPE)[keyof typeof CLIENT_INVALIDATION_EVENT_TYPE];

export type ClientInvalidationConnectionStatus =
	(typeof CLIENT_INVALIDATION_CONNECTION_STATUS)[keyof typeof CLIENT_INVALIDATION_CONNECTION_STATUS];
